import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-755b1b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__body-title" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20px","font-weight":"500","color":"#000"} }, " 配送情報の詳細"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"#FAAD14"} }, "*出荷倉庫を再割当すると、新しい注文が生成され、 元の注文内の商品はキャンセルされます。")
], -1))
const _hoisted_2 = { style: {"background-color":"#fff","padding-left":"10px","padding-bottom":"10px"} }
const _hoisted_3 = { class: "flex-ter ware" }
const _hoisted_4 = { class: "flex-ter afterWare" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("出荷倉庫（変更後）： ")
const _hoisted_6 = { class: "platformOrderNo" }
const _hoisted_7 = { style: {"margin":"8px"} }
const _hoisted_8 = { class: "flex-ter" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  type: "text"
}
const _hoisted_11 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_12 = { class: "flex-ter" }
const _hoisted_13 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "product-sku-word" }
const _hoisted_18 = { class: "flex just-center" }
const _hoisted_19 = { class: "show-one-line" }
const _hoisted_20 = {
  key: 1,
  class: "show-one-line"
}
const _hoisted_21 = {
  style: {"min-height":"84px"},
  class: "flex-col-center"
}
const _hoisted_22 = { class: "el-dialog__body-footer flex-ter-end" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 確定 ")

import { ref, onUnmounted, onMounted, nextTick, computed, watch } from 'vue'
import STable from '@/components/Table/index.vue'
// import { shopInfoDrawerColumns, groupTableConfig, combinationColumns } from './SalesPerspectiveData'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { QueryBindGoodsRespDTO } from '@/service/apis'
import AppLink from '@/components/common/AppLink.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { getWarehouseByCountry, isD2C, isJA, useRtfix, useSite } from '@/store'
import { dayjs, ElMessage, ElMessageBox, ElStep } from 'element-plus'
import DocumentaryRecord from '@/views/usercenter/Order/components/DocumentaryRecord.vue'
import { combinationStatusDict } from '../../data'
import { CustomerPlatformOrderItemRespDTO, QuerySwapStockOrderItemDTO, QuerySwapStockOrderRespDTO } from '@/service/order'
import ReplaceWareConfirm from './ReplaceWareConfirm.vue'
import HeaderTips from '@/views/product/Stock/components/HeaderTips.vue'
import ProductSku from '@/views/usercenter/Order/components/ProductSku.vue'
import ProductStats from '@/views/usercenter/Order/components/ProductStats.vue'
import {
  getShopLogistics
} from '@/apis/setup'
import { COUNTRY } from '@/global'
enum Enum_country {
  'CN' = t('中国'),
  'KR' = t('韩国'),
  'JP' = t('日本'),
}


export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const replaceWareConfirmRef = ref()


const imgHeader = 'https://static-s.theckb.com/BusinessMarket/Client/fund/split-'
const visiable = ref(false)
// 查看订单行数据
const tableData = ref<CustomerPlatformOrderItemRespDTO[]>([])
const rowData = ref<any>({})
const checkedList = ref<any[]>([])
const warehouse = ref<string>('ja')
const productTableConfig = {
  showSelection: true,
  setHeight: true,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  showHandler: false,
  selectable: (row: any) => !!row.supportSwapWareFlag && (!row.combinationOrderItemList?.length ?
    ((row.avaliableQuantity || 0) >= (row.orderQuantity || 0) && row.avaliableQuantity) || (rowData.value.wareCountry != row.purchaseCountry)
    : true)
}

// /** 待确认-sku-若是有变更理由则展示不同样式 */
// const tableRowClassName = ({ row }: any) => {
//   //   如果建议运输方式和原运输方式一样
//   if (!row.supportSwapWareFlag) {
//     return 'disabled-row'
//   }
//   return ''
// }

const handleSelection = (val: any) => {
  console.log(val, 'handleSelection')

  checkedList.value = val
}

const columns: any = computed(() => {
  return [
    {
      label: t('商品信息'),
      prop: 'shoppingInfo',
      align: 'center',
      width: 200,
      slotName: 'shoppingInfo'
    },
    {
      label: t('商品规格'),
      prop: 'productPropertiesName',
      align: 'center',
      slotName: 'productPropertiesName'
    },
    {
      label: t('平台商品SKU'),
      prop: 'productSku',
      align: 'center',
      slotName: 'productSku'
    },
    {
      label: t('商品状态'),
      align: 'center',
      slotName: 'shoppingStats'
    },
    {
      label: t('下单数量'),
      prop: 'avaliableQuantity',
      slotName: 'avaliableQuantity',
      slotHeadName: 'avaliableQuantityHead',
      align: 'center'
    }
  ]
})

const tableConfig = {
  showSelection: false,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList'
  // selectable: (row: any) => canApplyCancel(row, props.rowItem)
}

// 国家枚举
onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.shop-info-drawer')?.clientWidth || 0
}

const tableWidth = ref(0)

onMounted(async () => {
  changeTableWidth()
  window.addEventListener('resize', changeTableWidth)
})

const queryBindGoods = async () => {
  const res = await request.order.customer.platformOrderItemList({
    platformOrderId: rowData.value.platformOrderId,
    source: 2
  })
  tableData.value = res.data ?? []
  checkedList.value = []
}
const loading = ref(false)

const handleStartReplace = async () => {
  // /customer/additional/getAddress
  const res1 = await getShopLogistics({ warehouseCode: getWarehouseByCountry(rowData.value.wareCountry === 'CN' ? COUNTRY.JP : COUNTRY.JP) })
  const addtionIds = res1.data.additionItemList.map(i => i.additionId)
  // res1.data.additionItemList

  const filterAddtion = rowData.value.platformOrderDeliveryAdditionalList.filter(i => {
    return !addtionIds.includes(i.additionId)
  })

  if (filterAddtion.length) {
    ElMessageBox.confirm(`変更後の倉庫には${filterAddtion?.map(i => i.additionNameJp).join(',')}オプションが未設定です。倉庫を変更しますか？`, 'ご確認下さい', {
      confirmButtonText: t('确认'),
      cancelButtonText: t('取消'),
      type: 'warning',
      dangerouslyUseHTMLString: true
      /**
   * 执行数据校验操作
   */
    }).then(() => {
      checkData()
    })
  } else {
    checkData()
  }
}

const checkData = async () => {
  if (checkedList.value.length > 0) {
    try {
      loading.value = true
      const res = await request.order.customer.platformOrderSwapWare({
        platformOrderId: rowData.value.platformOrderId,
        platformOrderItemIds: checkedList.value.map(item => item.platformOrderItemId)
      })
      if (res.code == '0') {
        visiable.value = false
        ElMessage.success(`倉庫の変更が完了しました。注文番号：${res.data}。出荷倉庫：${rowData.value.wareCountry === 'CN' ? '日本倉庫(THE CKB)' : '中国倉庫'}。`)
        emits('success', res.data)
      }
      if (res.code === '22010009') {
        replaceWareConfirmRef.value.open()
        queryBindGoods()
      }
    } catch (error) {

    } finally {
      loading.value = false
    }
  } else {
    ElMessage.error(t('请选择商品'))
  }
}

expose({
  show: async (row: any) => {
    console.log(row, 'row')

    rowData.value = row
    if (row.wareCountry === 'JP') {
      warehouse.value = 'cn'
    } else {
      warehouse.value = 'jp'
    }
    await queryBindGoods()
    visiable.value = true
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "replaceWare_drawer",
      "model-value": visiable.value,
      "destroy-on-close": "",
      width: "1000px",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (visiable.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, "出荷倉庫（変更前）：" + _toDisplayString(rowData.value.wareCountry === 'CN' ? '中国倉庫' : '日本倉庫(THE CKB)'), 1),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_el_select, {
                  modelValue: warehouse.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((warehouse).value = $event)),
                  placeholder: "選択してください",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (rowData.value.wareCountry === 'CN')
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          label: "日本倉庫(THE CKB)",
                          key: "jp",
                          value: "jp"
                        }))
                      : _createCommentVNode("", true),
                    (rowData.value.wareCountry !== 'CN')
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          label: "中国倉庫",
                          key: "cn",
                          value: "cn"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, "THECKB注文番号：" + _toDisplayString(rowData.value?.platformOrderNo), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(STable, {
              ref: (_value, _refs) => {
                _refs['productRef'] = _value
              },
              tableData: tableData.value,
              tableConfig: productTableConfig,
              showPagination: false,
              columns: _unref(columns),
              showAllExpand: false,
              onSelectionChange: handleSelection
            }, {
              expand: _withCtx(({ scope }) => [
                _createVNode(STable, {
                  class: "combinationTable",
                  "table-data": scope.row.combinationOrderItemList,
                  columns: _unref(columns),
                  tableConfig: tableConfig,
                  showPagination: false,
                  showAllExpand: false
                }, {
                  shoppingInfo: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(ShoppingPreview, {
                        image: row.productSkuImg || row.productMainImg || '',
                        name: row.productTitleJp || '',
                        url: row.productDetailUrl || undefined
                      }, null, 8, ["image", "name", "url"])
                    ])
                  ]),
                  productSku: _withCtx(({ row }) => [
                    row
                      ? (_openBlock(), _createBlock(ProductSku, {
                          key: 0,
                          row: row
                        }, null, 8, ["row"]))
                      : _createCommentVNode("", true)
                  ]),
                  productPropertiesName: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                    }), 128))
                  ]),
                  shoppingStats: _withCtx(({ row }) => [
                    _createVNode(ProductStats, {
                      row: row,
                      isReplenish: row.smartReplenishFlag
                    }, null, 8, ["row", "isReplenish"])
                  ]),
                  orderQuantity: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.orderQuantity), 1)
                  ]),
                  _: 2
                }, 1032, ["table-data", "columns"])
              ]),
              shoppingStats: _withCtx(({ row }) => [
                (row.virtualFlag)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " - "))
                  : (row.productType === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        row
                          ? (_openBlock(), _createBlock(DocumentaryRecord, {
                              key: 0,
                              row: row,
                              cancelJump: true,
                              showExpress: true,
                              isReplenish: row.smartReplenishFlag
                            }, null, 8, ["row", "isReplenish"]))
                          : _createCommentVNode("", true)
                      ], 64))
              ]),
              avaliableQuantityHead: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(t)('下单数量')) + " ", 1),
                _createVNode(HeaderTips, {
                  content: rowData.value.wareCountry === 'CN' ? '日本倉庫の利用可能良品数' : '中国倉庫の利用可能良品数 ＋ 中国倉庫の利用可能処理中在庫数'
                }, null, 8, ["content"])
              ]),
              avaliableQuantity: _withCtx(({ row }) => [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(row.avaliableQuantity) + " ", 1),
                  ((row.avaliableQuantity || 0) - (row.orderQuantity || 0) < 0 && !!row.supportSwapWareFlag && !row.combinationOrderItemList?.length && rowData.value.wareCountry == row.purchaseCountry)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 在庫数不足、倉庫変更不可。 "))
                    : _createCommentVNode("", true)
                ])
              ]),
              shoppingInfo: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(ShoppingPreview, {
                    image: row.productSkuImg || row.productMainImg || '',
                    name: row.productTitleJp || '',
                    url: row.productDetailUrl || undefined
                  }, null, 8, ["image", "name", "url"]),
                  (row.productType === 3 && _unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                    : _createCommentVNode("", true),
                  (row.priorityShippingStatus && _unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        referrerPolicy: "no-referrer",
                        src: `${imgHeader}d2c-${_unref(useSite)()}.png`,
                        style: {"margin-left":"30px"},
                        class: "order-tag"
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (row.productType === 3 && !_unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                    : _createCommentVNode("", true),
                  (row.priorityShippingStatus && !_unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 3,
                        referrerPolicy: "no-referrer",
                        src: `${imgHeader}b2b-${_unref(useSite)()}.png`,
                        style: {"margin-left":"30px"},
                        class: "order-tag"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ]),
              productSku: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_tooltip, { effect: "light" }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(row.productSku), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        (row.productCode && row.productType !== 2)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              target: "_blank",
                              tag: "a",
                              to: _unref(useRtfix)('goods', {
                    params: { id: row.productCode ?? 'null' },
                  })
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, _toDisplayString(row.productSku), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(row.productSku), 1)),
                        _createVNode(CopyButton, {
                          text: row.productSku
                        }, null, 8, ["text"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              productPropertiesName: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                    return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["tableData", "columns"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              round: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visiable.value = false)),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              round: "",
              loading: loading.value,
              disabled: loading.value || !checkedList.value?.length,
              color: "#000",
              size: "large",
              type: "primary",
              onClick: checkData
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(ReplaceWareConfirm, {
      ref: (_value, _refs) => {
        _refs['replaceWareConfirmRef'] = _value
        replaceWareConfirmRef.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})